const ClientInvitationStatusEnum = {
  INVITED: 'invited',
  NOT_INVITED: 'not_invited',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
}

export default Object.freeze(ClientInvitationStatusEnum)
